<div class="header">
  <div class="left">
    <div class="title-group">
      <h2>Developer Console</h2>
      <a [routerLink]="['/access-docs']" class="access-docs-link">
        View Access Documentation
      </a>
    </div>
  </div>
  <div class="right">
    <app-breadcrumb class="breadcrumb-container"></app-breadcrumb>
    <button class="generate-btn" (click)="goToGenerateKey()" data-tour="dev-generate-btn">
      <span class="plus">+</span> Generate Key
    </button>
  </div>
</div>

@if (loading) {
  <div class="loading">Loading...</div>
}

@if (!loading && keys?.length === 0) {
  <div class="no-keys" data-tour="dev-no-keys">
    No API keys found.
  </div>
}

<div class="cards-container" data-tour="dev-keys-container">
  @for (key of keys; track key) {
    <div class="card" data-tour="dev-api-card">
      <div class="card-row"><span class="label">ID:</span> <span class="value">{{ key.id }}</span></div>
      <div class="card-row key-row">
        <span class="label">API Key:</span>
        <div class="key-value">
          <span class="value key-text">{{ key.api_key }}</span>
          <i
            class="fa fa-copy copy-icon"
            [matTooltip]="copiedKeyId === key.api_key ? 'Copied!' : 'Copy'"
            matTooltipPosition="above"
            #tooltip="matTooltip"
            (click)="copyKey(key.api_key, tooltip)"
          ></i>
        </div>
      </div>
      <div class="card-row"><span class="label">Request Limit:</span> <span class="value">{{ key.usage_limit }}</span></div>
      <div class="card-row"><span class="label">Expires At:</span> <span class="value">{{ key.expires_at | date:'mediumDate' }}</span></div>
      <div class="card-row active-toggle">
        <span class="label">Active:</span>
        <label class="switch">
          <input type="checkbox" [checked]="key.is_active" (click)="toggleActive($event, key)">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="card-row view-logs" data-tour="dev-view-logs">
        <a [routerLink]="['/view-logs', key.id]">
          View Logs
        </a>
      </div>
    </div>
  }
</div>
